import {
  cabeceraNumeroPedido,
  envolverDocumento,
  escaparHtml,
  formatearFechaHora,
  numeroPedidoDe,
} from "./html";

// Segundo papel: lo que hay que preparar y entregar, en el menor papel
// posible. Lleva número, hora, vendedor, todas las líneas —esElaborado es
// informativo— y las observaciones del pedido en un recuadro, en negrita y
// apenas más chicas que las líneas, para que cocina no las pase por alto y no
// se coman el papel. Nada del comprador ni del
// cobro: sin DNI, nombre fiscal, precios, descuentos, medio de pago, voucher,
// CAE ni QR. Tampoco el nombre del evento: en un puesto de un solo evento no
// le dice nada a la cocina.
export const renderComanda80mm = (documentos) => {
  const { pedido, lineas = [] } = documentos || {};
  const numero = numeroPedidoDe(pedido);
  const unidades = lineas.reduce((suma, linea) => suma + Number(linea.cantidad || 0), 0);

  const filas = lineas
    .map(
      (linea) => `
        <div class="fila comanda-linea">
          <span class="cant">${escaparHtml(linea.cantidad)} ×</span>
          <span style="flex:1;text-align:left;white-space:normal">${escaparHtml(linea.nombre)}</span>
        </div>
        ${linea.observacion ? `<p class="obs">${escaparHtml(linea.observacion)}</p>` : ""}`
    )
    .join("");

  const detalle = [formatearFechaHora(pedido?.fecha), pedido?.vendedor ? `Vendedor: ${pedido.vendedor}` : ""]
    .filter(Boolean)
    .join(" · ");

  const observaciones = pedido?.observaciones
    ? `<div class="comanda-obs"><p class="titulo">OBSERVACIONES</p><p class="texto">${escaparHtml(pedido.observaciones)}</p></div>`
    : "";

  const cuerpo = `
    ${cabeceraNumeroPedido(pedido, "COMANDA")}
    ${detalle ? `<p class="centro chico">${escaparHtml(detalle)}</p>` : ""}
    <div class="sep"></div>
    ${filas}
    <div class="fila chico negrita" style="padding-top:0.6mm"><span>Total de unidades</span><span>${escaparHtml(unidades)}</span></div>
    ${observaciones}
  `;

  return envolverDocumento({ titulo: `Comanda ${numero}`.trim(), cuerpo });
};
